module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-at-c8f0967bd0b6d760cad941e8bd011e4f.svg";